module.exports = __webpack_public_path__ + "static/img/certificate_6.1b6a9cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/who_are_we/certificate_6.png
// module id = Ur7k
// module chunks = 94